import { useEffect, useId, useState } from 'react'
import { createPortal } from 'react-dom'
import { Droplets } from 'lucide-react'
import Modal from '../../../../components/ERP/Modal/Modal'
import { patientService } from '../../../../services/patientApi'

function NutritionWaterButton({ patientId, patientName, date, onAdded, variant = 'button', tourAnchor }) {
  const formId = useId()
  const [open, setOpen] = useState(false)
  const [value, setValue] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!open) return
    setValue('')
    setError('')
  }, [open])

  const submit = async (event) => {
    event.preventDefault()
    const volumeMl = Number(value)
    if (!Number.isInteger(volumeMl) || volumeMl < 1 || volumeMl > 5000) {
      setError('Informe um volume inteiro entre 1 e 5000 ml')
      return
    }
    setSaving(true)
    setError('')
    try {
      await patientService.addNutritionHydration(patientId, { volumeMl, date })
      setValue('')
      await onAdded()
      setOpen(false)
    } catch (err) {
      setError(err.response?.data?.message || 'Não foi possível lançar a água livre')
    } finally {
      setSaving(false)
    }
  }

  const modal = (
      <Modal
        isOpen={open}
        onClose={() => setOpen(false)}
        title="Água livre"
        subtitle="Volume ingerido agora"
        icon={<Droplets size={22} />}
        className="nut-water-modal"
        size="small"
        footer={(
          <button type="submit" form={formId} disabled={saving || !String(value).trim()}>
            {saving ? 'Salvando...' : 'Registrar'}
          </button>
        )}
      >
        <form id={formId} onSubmit={submit}>
          {error && <p className="patients-alert-strip">{error}</p>}
          <p className="patients-note">Paciente: <strong>{patientName}</strong></p>
          <div className="patients-field">
            <label htmlFor={`${formId}-volume`}>Volume (ml)</label>
            <input
              id={`${formId}-volume`}
              type="number"
              inputMode="numeric"
              required
              step="1"
              min="1"
              max="5000"
              placeholder="100"
              value={value}
              onChange={(event) => setValue(event.target.value)}
            />
          </div>
        </form>
      </Modal>
  )

  return (
    <>
      {variant === 'fab' ? (
        <button
          type="button"
          className="patients-note-fab is-water"
          data-onboarding={tourAnchor || undefined}
          aria-label="Água livre"
          title="Água livre"
          onClick={() => setOpen(true)}
        >
          <Droplets size={22} />
        </button>
      ) : (
        <button type="button" className="patients-btn nut-water-trigger" onClick={() => setOpen(true)}>
          <Droplets size={14} />
          Água livre
        </button>
      )}
      {createPortal(modal, document.body)}
    </>
  )
}

export default NutritionWaterButton
